// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bde299b1","667":"3f4af8df"}[chunkId] + ".chunk.js";
};